var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',_vm._g(_vm._b({key:_vm.key,staticStyle:{"width":"100%"},attrs:{"props":_vm.config,"clearable":""}},'el-cascader',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }